import * as React from 'react';

const Redirect16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.75 2a.75.75 0 0 0 0 1.5h1.689L7 7.94A.75.75 0 0 0 8.06 9l4.44-4.439V6.25a.75.75 0 0 0 1.5 0V3a1 1 0 0 0-1-1zm2.75 7.75a.75.75 0 0 1 1.5 0v2.75a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 12.5v-9A1.5 1.5 0 0 1 3.5 2h2.75a.75.75 0 0 1 0 1.5H3.5v9h9z"
  }
));
Redirect16.Size = 16;
Redirect16.Title = "Redirect";

export { Redirect16 as default };
